import MobileContext from 'context/MobileContext';
import React, { useContext, useState } from 'react';
import MobileVisual from './MobileVisual';
import DesktopVisual from './DesktopVisual';
import styles from './styles.module.css';
import Text from 'components/shared/Text';
const Packages = ({ userPackagesData, userPackagesMessage, loadingPackages }) => {
  const isMobile = useContext(MobileContext);

  return (
    <div className={styles.body}>
      {isMobile ? <div className={styles.divider}></div> : null}

      <Text className={styles.mainHeading}>My Packages</Text>
      {isMobile ? (
        <MobileVisual
          userPackagesData={userPackagesData}
          isPackagesLoading={loadingPackages}
          userPackagesMessage={userPackagesMessage}
        />
      ) : (
        <DesktopVisual
          userPackagesData={userPackagesData}
          isPackagesLoading={loadingPackages}
          userPackagesMessage={userPackagesMessage}
        />
      )}
    </div>
  );
};

export default Packages;
